import React from "react";
import { Suspense } from "react";
import LoadingScreen from "./LoadingScreen";

function SuspenseContainer({ children }) {
  return <Suspense fallback={<LoadingScreen />}>{children}</Suspense>;
}

export default SuspenseContainer;
